import { useState, type KeyboardEvent } from "react";
import { Loader2, SendHorizonal } from "lucide-react";

import { Button } from "@/components/ui/button";

type PromptBarProps = {
  onSend: (prompt: string) => void;
  busy: boolean;
  placeholder: string;
  sendLabel: string;
};

export const PromptBar = ({
  onSend,
  busy,
  placeholder,
  sendLabel,
}: PromptBarProps) => {
  const [prompt, setPrompt] = useState("");

  const submit = () => {
    const trimmed = prompt.trim();
    if (!trimmed || busy) return;
    onSend(trimmed);
    setPrompt("");
  };

  const onKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <div className="flex items-end gap-3 border bg-card p-3 transition-colors focus-within:border-foreground/60">
      <textarea
        value={prompt}
        onChange={(event) => setPrompt(event.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        rows={2}
        className="min-h-[3rem] flex-1 resize-y border-none bg-transparent text-sm leading-relaxed outline-none placeholder:text-muted-foreground/70"
      />
      <Button onClick={submit} disabled={busy || !prompt.trim()}>
        {busy ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <SendHorizonal className="h-4 w-4" />
        )}
        {sendLabel}
      </Button>
    </div>
  );
};
